import { useState } from 'react';

import { Icon } from '~/shared/ui/Icon/Icon';
import { Typography } from '~/shared/ui/Typography/Typography';

import { Markdown } from '../Markdown/Markdown';

import { Arrow, Body, Content, Header, Root } from './Dropdown.ui';

export type DropdownProps = {
  className?: string;
  title: string;
  desc: string;
};

export const Dropdown = ({ title, desc, className }: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Root isOpen={isOpen} className={className}>
      <Header
        onClick={() => setIsOpen((prev) => !prev)}
        type="button"
        tabIndex={0}
      >
        <Typography.Medium>{title}</Typography.Medium>
        <Arrow isOpen={isOpen}>
          <Icon name="chevron-up" />
        </Arrow>
      </Header>
      <Body isOpen={isOpen}>
        <Content isOpen={isOpen}>
          <Markdown text={desc} />
        </Content>
      </Body>
    </Root>
  );
};
